const regex = /^\d{18}$/;

export const validateMdmId = (id: string) => regex.test(id);
